import {Routes} from '@angular/router';
import {authRoutes} from '@auth/routes';
import {adminGuard, authGuard, multiUserGuard} from '@auth/guards';
import {coreRoutes} from '@core/routes';
import {adminRoutes} from '@admin/routes';
import {penalRoutes} from '@penal/routes';
import {compliantsRoutes} from '@compliants/routes';
import {academyRoutes} from '@academy/routes';
import {reportsRoutes} from '@reports/routes';
import {compliantsClientRoutes} from '@compliants-client/routes';
import {companyConfigGuard} from '@compliants-client/guards';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: '',
    children: [
      ...authRoutes
    ]
  },
  {
    path: '',
    loadComponent: () => import('@core/pages/dashboard/dashboard').then(m => m.Dashboard),
    children: [
      ...coreRoutes,
      ...penalRoutes,
      ...compliantsRoutes,
      ...academyRoutes,
      ...reportsRoutes
    ],
    canActivate: [multiUserGuard]
  },
  {
    path: 'compliants/client/:companyId',
    loadComponent: () => import('@layouts/compliants-layout/compliants-layout').then(m => m.CompliantsLayout),
    children: [
      ...compliantsClientRoutes
    ],
    canActivate: [companyConfigGuard]
  },
  {
    path: 'multi-user',
    loadComponent: () => import('@core/pages/multiuser/multiuser').then(m => m.Multiuser),
    canActivate: [authGuard]
  },
  {
    path: '',
    children: [
      ...adminRoutes
    ],
    canActivate: [authGuard, adminGuard],
  },
  {
    path: 'error/:code',
    pathMatch: 'full',
    redirectTo: '/error',
  },
  {
    path: '**',
    loadComponent: () => import('@core/pages/error/error').then(m => m.Error)
  }
];
